import { useEffect, useRef } from "react";
import { useAuth } from "../contexts/AuthContext";
import { registrarError } from "../utils/errores";

// Sin UI — solo escucha errores de JS y promesas sin atrapar que el
// ErrorBoundary no puede ver (porque no ocurren durante el render), y los
// manda a la misma bitácora.
export default function ErrorReporter() {
  const { userProfile } = useAuth();
  const usuarioRef = useRef(userProfile);
  usuarioRef.current = userProfile;

  useEffect(() => {
    function onError(event) {
      registrarError({ mensaje: event.message, stack: event.error?.stack, tipo: "js", usuario: usuarioRef.current });
    }
    function onRejection(event) {
      registrarError({ mensaje: String(event.reason?.message || event.reason), stack: event.reason?.stack, tipo: "promesa", usuario: usuarioRef.current });
    }
    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);

  return null;
}
